export const remoteErrorReaction = (context) => (error) => {
	const message = error?.message?.message
	let extraData = ''
	if (error?.message?.parameters) {
		error.message.parameters.forEach((param) => (extraData += param + ' '))
	}
	context.actions.toast.addMessage({ message, extraData })
}
